import { Component } from '@angular/core';

@Component({
  selector: 'app-modal-cancellation-policy',
  templateUrl: './modal-cancellation-policy.component.html',
})
export class ModalCancellationPolicyComponent {}
